








































































































































































































































































































































































































































































































































































import performanceDialog from "./performanceDialog.vue";
import performanceTotalDialog from "../performanceTotalDialog.vue";
import previewDialog from "./previewDialog.vue";
import payslipDialog from "../../payslipDialog.vue";
import {
  getSalaryStaffSettingDetailApi,
  getSalaryStaffSettingDetailData,
  saveSalarySettingApi,
  saveSalarySettingData,
  getSalarySettingDetailApi,
} from "@/api/salary";
import { Vue, Component } from "vue-property-decorator";
@Component({
  components: {
    performanceDialog,
    performanceTotalDialog,
    previewDialog,
    payslipDialog,
  },
})
export default class extends Vue {
  detailData = {
    group_one_type: 0,
    group_two_type: 0,
    calculate_type: 0,
    performance_gradient: [] as any[],
    salary_items: [] as any[],
    staff: {} as any,
  };
  groupOneTypeZh = {
    0: "-",
    1: "统一设置",
    2: "按班级设置",
    3: "按课程设置",
  };
  groupTwoTypeZh = {
    0: "-",
    1: "综合统计",
    2: "按课次单独统计",
  };
  calculateTypeZh = {
    0: "-",
    1: "无梯度",
    2: "超额累计",
    3: "全额累计",
  };
  created() {
    this.init();
  }
  init() {
    const sid = Number(this.$route.query.staff_id);
    if (!sid) {
      return false;
    }
    const params: getSalaryStaffSettingDetailData = {
      staff_id: sid,
    };
    getSalaryStaffSettingDetailApi(params).then((res: any) => {
      if (res.data.group_one_type === 0) {
        res.data.group_one_type = 1;
      }
      if (res.data.group_two_type === 0 && res.data.calculate_type === 0) {
        getSalarySettingDetailApi().then((storeSetting: any) => {
          res.data.group_two_type = storeSetting.data.group_two_type;
          res.data.calculate_type = storeSetting.data.calculate_type;
          this.detailData = res.data;
        });
      } else {
        this.detailData = res.data;
      }
    });
  }
  handleUpdateStaticData() {
    const sid = Number(this.$route.query.staff_id);
    if (!sid) {
      return false;
    }
    const params: getSalaryStaffSettingDetailData = {
      staff_id: sid,
    };
    if (this.detailData.group_one_type) {
      params.settle_style = this.detailData.group_one_type;
    }
    getSalaryStaffSettingDetailApi(params).then((res: any) => {
      this.detailData.salary_items = res.data.salary_items;
    });
  }
  handleTypeOneChange(v: number) {
    const sid = Number(this.$route.query.staff_id);
    if (!sid) {
      return false;
    }
    const params: getSalaryStaffSettingDetailData = {
      staff_id: sid,
    };
    if (v) {
      params.settle_style = v;
    }
    getSalaryStaffSettingDetailApi(params).then((res: any) => {
      this.detailData.group_one_type = v;
      this.detailData.performance_gradient = res.data.performance_gradient;
      this.detailData.staff = res.data.staff;
    });
  }
  handleTypeTwoChange(data: any) {
    this.detailData.calculate_type = data.calculate_type;
    this.detailData.group_two_type = data.group_two_type;
    const copy = [...this.detailData.performance_gradient];
    // 统计规则1对应结算类型12，统计规则2对应结算类型23，切换时要重置
    // 注意price_type的同步
    copy.map((item: any) => {
      if (data.group_two_type === 1 && item.range_type === 3) {
        item.range_type = 1;
      }
      if (data.group_two_type === 2 && item.range_type === 1) {
        item.range_type = 2;
      }
      item.price_type = item.range_type;
      item.lesson_price = "0.00";
    });
    if (data.calculate_type === 1) {
      // 无梯度时所有梯度设置为一条默认值，后端要求
      copy.map((item: any) => {
        item.gradient_list = [
          { range_start: "0", range_end: "0", unit_price: "0" },
        ];
      });
    } else if (data.calculate_type > 1) {
      // 如果是从无梯度到有梯度，后端只会返回无梯度时的一条默认值，所以要补充一条梯度（正常梯度最少为两条）
      copy.map((item: any) => {
        if (item.gradient_list.length < 2) {
          item.gradient_list = [
            { range_start: "0", range_end: "0", unit_price: "0" },
            { range_start: "0", range_end: "0", unit_price: "0" },
          ];
        }
      });
    }
    this.detailData.performance_gradient = copy;
  }
  solveFloatNumber(v: number | string, limit: number) {
    const res = Math.abs(Number(v));
    if (res) {
      return res.toFixed(limit);
    } else {
      return "0.00";
    }
  }
  handleSubmit() {
    const sid = Number(this.$route.query.staff_id);
    if (!sid) {
      return false;
    }
    const salary_items = this.detailData.salary_items.map(
      (item: { salary_item_id: number; salary_item_value: string }) => {
        return {
          salary_item_id: item.salary_item_id,
          salary_item_value: item.salary_item_value,
        };
      }
    );
    if (this.detailData.staff.is_teach === 1) {
      // 检查梯度数据合法性
      if (
        this.detailData.calculate_type === 2 ||
        this.detailData.calculate_type === 3
      ) {
        let rangePass = true;
        this.detailData.performance_gradient.map((item: any) => {
          item.gradient_list.map((it: any, idx: number) => {
            if (idx !== item.gradient_list.length - 1) {
              rangePass = Number(it.range_end) > Number(it.range_start);
            }
          });
        });
        if (!rangePass) {
          this.$message({
            type: "warning",
            message: "梯度输入有误",
          });
          return false;
        }
      }
      // 检查结算类型合法性
      let rangeTypePass = true;
      this.detailData.performance_gradient.map((item: any) => {
        rangeTypePass = item.range_type !== 0;
      });
      if (!rangeTypePass) {
        this.$message({
          type: "warning",
          message: "结算类型必须设置",
        });
        return false;
      }
      const params: saveSalarySettingData = {
        staff_id: sid,
        salary_items: salary_items,
        group_one_type: this.detailData.group_one_type,
        group_two_type: this.detailData.group_two_type,
        calculate_type: this.detailData.calculate_type,
      };
      if (
        this.detailData.calculate_type !== 0 &&
        this.detailData.performance_gradient.length > 0
      ) {
        const performance_gradient = this.detailData.performance_gradient.map(
          (item: any) => {
            let group_one_id = 0;
            if (this.detailData.group_one_type === 2) {
              group_one_id = item.class[0].class_id;
            }
            if (this.detailData.group_one_type === 3) {
              group_one_id = item.course.course_id;
            }
            return {
              group_one_id: group_one_id,
              range_type: item.range_type,
              lesson_price: item.lesson_price,
              price_type: item.price_type,
              range: item.gradient_list,
            };
          }
        );
        params.performance_gradient = performance_gradient;
      }
      saveSalarySettingApi(params).then(() => {
        this.$message({
          type: "success",
          message: "设置成功",
        });
        this.$router.go(-1);
      });
    } else {
      // 不授课，不结算绩效
      const params: saveSalarySettingData = {
        staff_id: sid,
        salary_items: salary_items,
      };
      saveSalarySettingApi(params).then(() => {
        this.$message({
          type: "success",
          message: "设置成功",
        });
        this.$router.go(-1);
      });
    }
  }
}
